module.exports = __webpack_public_path__ + "img/completed-animate.0d368cfa.svg";